/**
 * Where a saved sentence is posted, and under what field.
 *
 * **Constants of their own, to keep the whole user shell out of the
 * browser bundle.** `save-liju-markup.ts` used to hold them and now draws a
 * compact remove icon out of `shell.generated.ts`. That module is the page
 * Hugo published, 27 KB of the site's chrome, and esbuild follows an import
 * whether or not anything reads the value behind it. `src/site/save-liju.ts`
 * wants the paths and the field names and none of the markup.
 *
 * `save-liju-markup.ts` re-exports them. A caller drawing markup still
 * has one module to reach for, and `src/assets/script-bundles.test.ts` fails
 * where the shell finds its way back into the bundle.
 */

export const lijuPath = "/user/liju/";
export const lijuItemsPath = "/user/liju/items/";
export const savedLijuField = "uuid";

/**
 * The field the script posts saying which way a press goes, `save` or
 * `remove`.
 *
 * The button says what it offers, and the press asks for that. A page drawn
 * before the reader saved the sentence somewhere else (another tab, or Back to
 * a page the browser kept) still offers to save it, and a toggle would remove
 * it (CB-44). A form posted with no script carries no such field and turns the
 * sentence over.
 */
export const savedLijuIntentField = "intent";

/** What a press can ask for, in {@link savedLijuIntentField}. */
export const savedLijuIntents = { save: "save", remove: "remove" } as const;
